import React from "react";

const Edit = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
          className="u_fill"
          d="M19.629 8.818l7.553 7.555L9.554 34H2v-7.555L19.629 8.816v.002zM22.146 6.3l3.777-3.779a1.78 1.78 0 012.518 0L33.48 7.56a1.78 1.78 0 010 2.518L29.7 13.854 22.147 6.3z"
          fill={fill}
      />
    </svg>
);

export default Edit;
